export default __webpack_public_path__ + "locales/pt-BR/DataReassignmentDialog.json?hash=b550b3311cc4bcfd2559dac7cae9aef7";